import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAdminAuth, updateAdminProfileFields } from '../../store/slices/adminAuthSlice';
import { Box, Typography, Card, CardContent, Divider, TextField, Button, Stack, useTheme, Avatar } from '@mui/material';
import AdminChangePassword from './AdminChangePassword';
import AdminProfileAPITabs from './AdminProfileAPITabs';
import { toast } from 'react-toastify';
import { updateAdminProfile } from '../../api/admin';

const UserProfile = () => {
  const { admin, token } = useSelector(selectAdminAuth);
  const [firstName, setFirstName] = React.useState(admin?.firstName || '');
  const [lastName, setLastName] = React.useState(admin?.lastName || '');
  const [saving, setSaving] = React.useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await updateAdminProfile(token, firstName, lastName);
      toast.success('Name updated successfully!');
      dispatch(updateAdminProfileFields({ firstName, lastName }));
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to update profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4 }}>
      <AdminProfileAPITabs selectedTab={0} />
      <Box
        sx={{
          maxHeight: { xs: '60vh', sm: '70vh', md: '75vh' },
          overflow: 'auto',
          px: { xs: 1, sm: 2 },
          py: { xs: 2, sm: 3 },
          scrollbarWidth: 'thin',
          scrollbarColor: '#bdbdbd #f8fafc',
          '&::-webkit-scrollbar': { width: 8, background: '#f8fafc', borderRadius: 8 },
          '&::-webkit-scrollbar-thumb': { background: '#bdbdbd', borderRadius: 8 },
        }}
      >
        <Card sx={{ mb: 3, boxShadow: 6, border: '1px solid', borderColor: theme.palette.mode === 'light' ? '#e3e8ee' : '#23272b', background: theme.palette.mode === 'light' ? '#fff' : '#23272b', px: { xs: 1, sm: 4 }, py: { xs: 2, sm: 4 } }}>
          <CardContent sx={{ p: 0 }}>
            <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
              <Avatar
                sx={{
                  width: 84,
                  height: 84,
                  fontSize: 36,
                  fontWeight: 700,
                  background: 'linear-gradient(135deg, #1976d2 30%, #42a5f5 90%)',
                  color: '#fff',
                  boxShadow: 3,
                  mb: 1.5,
                  border: '4px solid #fff',
                }}
              >
                {((firstName && lastName) ? `${firstName[0]}${lastName[0]}` : (firstName ? firstName[0] : 'A')).toUpperCase()}
              </Avatar>
              <Typography variant="h6" fontWeight={700} color="text.primary">
                {firstName || lastName ? `${firstName} ${lastName}` : 'Admin'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {admin?.email || '-'}
              </Typography>
            </Box>
            <Stack spacing={3}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField label="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} fullWidth sx={{ borderRadius: 2, background: '#f7f9fb' }} />
                <TextField label="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} fullWidth sx={{ borderRadius: 2, background: '#f7f9fb' }} />
              </Stack>
              {/* <TextField label="Email" value={admin?.email || '-'} fullWidth disabled sx={{ borderRadius: 2, background: '#f7f9fb' }} /> */}
              <Button variant="contained" onClick={handleSave} disabled={saving} sx={{ alignSelf: 'flex-start', minWidth: 100, fontWeight: 400, fontSize: 14, py: 0.7, px: 2, boxShadow: 2, borderRadius: 1, transition: 'background 0.2s', '&:hover': { background: theme.palette.primary.dark } }}>{saving ? 'Saving...' : 'Save'}</Button>
              <Divider sx={{ my: 2 }} />
              <AdminChangePassword />
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default UserProfile; 